import { TaskStatus } from '@mosey/api-types';
import { useTask, useTaskSourceQuestion } from '../utils/hooks';
import { TaskHeader } from '../common/TaskHeader';
import { TaskQuestionAnswered } from './questions/TaskQuestionAnswered';
import { TaskContainer } from './TaskContainer';
import { TaskQuestionUnanswered } from './questions/TaskQuestionUnanswered';

export const TaskQuestion = () => {
  const { status } = useTask();
  const { is_editable: isEditable } = useTaskSourceQuestion();

  return (
    <TaskContainer>
      <TaskHeader />

      {status === TaskStatus.done && !isEditable ? (
        <TaskQuestionAnswered />
      ) : (
        <TaskQuestionUnanswered />
      )}
    </TaskContainer>
  );
};
